/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var getDateLocaleFormat = function getDateLocaleFormat(locale) {
  var localeDate;
  try {
    localeDate = new Intl.DateTimeFormat(locale, {
      timeZone: 'UTC'
    }).format(new Date('2012-12-21T00:00:00.000+00:00'));
  } catch (err) {
    return 'm/d/Y';
  }

  //  The following regex is testing for any delimiter listed, basically no letters or numbers
  //  if it can't find any matches, it'll fall back to '/'
  //  This is an issue in ie11 with zh, they show the date as 1970‎年‎10‎月‎30‎日
  var separator = localeDate[localeDate.search(/[~`!#$%^&*+=\-[\]';,./{}|\\":<>?]/)] || '/';
  var dateOrder = ['2012', '12', '21'].sort(function (a, b) {
    return localeDate.indexOf(a) - localeDate.indexOf(b);
  });
  return dateOrder.join(separator).replace(/2012/, 'Y').replace(/12/, 'm').replace(/21/, 'd');
};
var getDateLocaleFormat$1 = getDateLocaleFormat;

export { getDateLocaleFormat$1 as default };
